/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateFunnelSessionRequest,
  CreateFunnelSessionResponse,
  FunnelLeadResponse,
  HTTPValidationError,
  UpdateFunnelLeadRequest
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Mint an anonymous funnel session.

Returns the raw session token; the client must persist it and send it on
subsequent funnel requests via the X-Funnel-Session header. The raw token
never appears in the database — only its HMAC-SHA256 hash is stored.
 * @summary Create Funnel Session
 */
export const intakeCreateSession = (
    createFunnelSessionRequest: CreateFunnelSessionRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CreateFunnelSessionResponse>(
      {url: `/v1/intake/session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFunnelSessionRequest, signal
    },
      );
    }
  


export const getIntakeCreateSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof intakeCreateSession>>, TError,{data: CreateFunnelSessionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof intakeCreateSession>>, TError,{data: CreateFunnelSessionRequest}, TContext> => {

const mutationKey = ['intakeCreateSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof intakeCreateSession>>, {data: CreateFunnelSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  intakeCreateSession(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntakeCreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof intakeCreateSession>>>
    export type IntakeCreateSessionMutationBody = CreateFunnelSessionRequest
    export type IntakeCreateSessionMutationError = HTTPValidationError

    /**
 * @summary Create Funnel Session
 */
export const useIntakeCreateSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof intakeCreateSession>>, TError,{data: CreateFunnelSessionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof intakeCreateSession>>,
        TError,
        {data: CreateFunnelSessionRequest},
        TContext
      > => {

      const mutationOptions = getIntakeCreateSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get the current lead data for the resolved funnel session.
 * @summary Get My Funnel Lead
 */
export const intakeGetMyLead = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<FunnelLeadResponse>(
      {url: `/v1/intake/session/me/lead`, method: 'GET', signal
    },
      );
    }
  



export const getIntakeGetMyLeadQueryKey = () => {
    return [
    `/v1/intake/session/me/lead`
    ] as const;
    }

    
export const getIntakeGetMyLeadQueryOptions = <TData = Awaited<ReturnType<typeof intakeGetMyLead>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof intakeGetMyLead>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIntakeGetMyLeadQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof intakeGetMyLead>>> = ({ signal }) => intakeGetMyLead(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof intakeGetMyLead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IntakeGetMyLeadQueryResult = NonNullable<Awaited<ReturnType<typeof intakeGetMyLead>>>
export type IntakeGetMyLeadQueryError = HTTPValidationError


export function useIntakeGetMyLead<TData = Awaited<ReturnType<typeof intakeGetMyLead>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof intakeGetMyLead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof intakeGetMyLead>>,
          TError,
          Awaited<ReturnType<typeof intakeGetMyLead>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntakeGetMyLead<TData = Awaited<ReturnType<typeof intakeGetMyLead>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof intakeGetMyLead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof intakeGetMyLead>>,
          TError,
          Awaited<ReturnType<typeof intakeGetMyLead>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIntakeGetMyLead<TData = Awaited<ReturnType<typeof intakeGetMyLead>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof intakeGetMyLead>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Funnel Lead
 */

export function useIntakeGetMyLead<TData = Awaited<ReturnType<typeof intakeGetMyLead>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof intakeGetMyLead>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIntakeGetMyLeadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Partially update the lead for the resolved funnel session.

Only fields explicitly present in the request body are written.
 * @summary Update My Funnel Lead
 */
export const intakeUpdateMyLead = (
    updateFunnelLeadRequest: UpdateFunnelLeadRequest,
 ) => {
      
      
      return customCatchBackendFetcher<FunnelLeadResponse>(
      {url: `/v1/intake/session/me/lead`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFunnelLeadRequest
    },
      );
    }
  


export const getIntakeUpdateMyLeadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof intakeUpdateMyLead>>, TError,{data: UpdateFunnelLeadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof intakeUpdateMyLead>>, TError,{data: UpdateFunnelLeadRequest}, TContext> => {

const mutationKey = ['intakeUpdateMyLead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof intakeUpdateMyLead>>, {data: UpdateFunnelLeadRequest}> = (props) => {
          const {data} = props ?? {};

          return  intakeUpdateMyLead(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntakeUpdateMyLeadMutationResult = NonNullable<Awaited<ReturnType<typeof intakeUpdateMyLead>>>
    export type IntakeUpdateMyLeadMutationBody = UpdateFunnelLeadRequest
    export type IntakeUpdateMyLeadMutationError = HTTPValidationError

    /**
 * @summary Update My Funnel Lead
 */
export const useIntakeUpdateMyLead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof intakeUpdateMyLead>>, TError,{data: UpdateFunnelLeadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof intakeUpdateMyLead>>,
        TError,
        {data: UpdateFunnelLeadRequest},
        TContext
      > => {

      const mutationOptions = getIntakeUpdateMyLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    